import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';

import { usePartnerShares } from '../context/PartnerSharesContext';

const PartnerSharesTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = usePartnerShares();

  const columns = [
    { key: 'number', content: t('Nr') },

    { key: 'shares-count', content: t('NrPart.'), textPosition: 'right' },

    // {
    //   key: 'nominal-value',
    //   content: t('Nominal'),
    //   textPosition: 'right',
    //   hideOnMobile: true,
    // },

    !data.hasPartnerSharesRangeDisabled &&
      !data.hasPartnerSharesRangeDisabled && {
        key: 'holding-class-name',
        content: t('Class'),
        hideOnMobile: true,
      },

    !data.hasPartnerSharesRangeDisabled && {
      key: 'from',
      content: t('From'),
      textPosition: 'right',
    },

    !data.hasPartnerSharesRangeDisabled && {
      key: 'to',
      content: t('To'),
      textPosition: 'right',
    },

    !data.hasPartnerSharesRangeDisabled &&
      data.isAdmin && {
        key: 'encumbrances',
        content: t('Encumbrance'),
        textPosition: 'center',
        hideOnMobile: true,
      },

    !data.hasPartnerSharesRangeDisabled &&
      data.showSharesTitleColumn && {
        key: 'shares-title',
        content: t('Title'),
        textPosition: 'center',
      },
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default PartnerSharesTableHeader;
